import React, { useState, useEffect } from 'react';
import QuickMenu from '../../components/QuickMenu/QuickMenu';
import { getParlamentMembers } from '../../api/councilService';



const CouncilMembers = () => {
  const [members, setMembers] = useState([]);

  useEffect(() => {
    const fetchMembers = async () => {
      try {
        const response = await getParlamentMembers();
        if (response.isSuccess) {
          setMembers(response.data.items);
        }
      } catch (error) {
        console.error('Error fetching council members:', error);
      }
    };

    fetchMembers();
  }, []);
  return (
    <div className="council-members-page">
      <div className="container py-5">
        <div className="row">
          <QuickMenu />
          
          <div className="col-md-10">
            <div className="council-members-content">
              <h1 className="page-title">Meclis Üyeleri</h1>
              
              <div className="mayor-section">
                <div className="mayor-card">
                  <div className="mayor-image">
                    <img src="/assets/images/baskan-gorev.png" alt="MEHMET DÖNMEZ" onError={(e) => {
                      e.target.src = '/assets/images/placeholder.jpg';
                    }} />
                  </div>
                  <div className="mayor-info">
                    <h2>MEHMET DÖNMEZ</h2>
                    <p>İSKENDERUN BELEDİYE BAŞKANI</p>
                  </div>
                </div>
              </div>

              <div className="members-grid">
                {members.map((member) => (
                  <div key={member.guid} className="member-card">
                    <div className="member-image">
                      <img src={member.pictureUrl} alt={member.name} onError={(e) => {
                        e.target.src = '/assets/images/placeholder.jpg';
                      }} />
                    </div>
                    <div className="member-info">
                      <h3>{member.name}</h3>
                      <p className={`party ${member.partyName.includes('MHP') ? 'mhp' : member.partyName.includes('AK') ? 'akp' : 'chp'}`} style={{ backgroundColor: member.partyColor }}>
                        {member.partyName}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CouncilMembers;
